import React from "react";

const LoadingModal = ({ show }) => {
  if (!show) return null;

  return (
    <>
      {/* Overlay Hitam Transparan */}
      <div 
        className="modal-backdrop fade show" 
        style={{ zIndex: 1050 }}
      ></div>
      
      {/* Modal Content */}
      <div
        className="modal fade show"
        style={{ display: "block", zIndex: 1055 }}
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body text-center py-5">
              <div 
                className="spinner-border text-primary mb-3" 
                role="status" 
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <h6 className="mb-0 text-secondary font-weight-bold">
                Loading . . .
              </h6>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoadingModal;